import { render, staticRenderFns } from "./AttachmentList.vue?vue&type=template&id=e19b95b4&scoped=true"
import script from "./AttachmentList.vue?vue&type=script&lang=ts"
export * from "./AttachmentList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e19b95b4",
  null
  
)

export default component.exports